export const errorDutyRequest='error duty async request';
export const errorDutySuccess='error duty async success';
export const errorDutyFailure='error duty async failure';


// WEBPACK FOOTER //
// ./src/entry_app/question_box/error_duty/actionType.js